import Icon from '../components/Icon.vue'

Icon.register({"search-location":{"width":512,"height":512,"paths":[{"d":"M505 442.7L405.3 343C400.8 338.5 394.7 336 388.3 336H372C399.6 300.7 416 256.3 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416C256.3 416 300.7 399.6 336 372V388.3C336 394.7 338.5 400.8 343 405.3L442.7 504.9C452.1 514.4 467.3 514.4 476.6 504.9L504.9 476.6C514.3 467.3 514.3 452.1 505 442.7zM208 352C128.5 352 64 287.6 64 208 64 128.4 128.4 64 208 64 287.6 64 352 128.3 352 208 352 287.5 287.7 352 208 352zM208 112C167.3 112 134.2 145.1 134.2 185.8 134.2 218.8 182.5 278.9 201 300.7A9.2-9.2 0 0 1 215.1 300.7C233.6 278.9 281.9 218.8 281.9 185.8 281.9 145.1 248.8 112 208 112zM208 208C194.8 208 184 197.3 184 184 184 170.7 194.8 160 208 160S232 170.7 232 184C232 197.3 221.3 208 208 208z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/search-location.js
// module id = null
// module chunks = 